/* ============================================================
   GOB — geo store recommendation (v4.2 logic, unchanged)
   Extracted 2026-08-25 from snippets/gob-geo-path-fix.liquid.

   8.6 KB that used to be inline on every page and could never be cached.
   The three Liquid-derived values (visitor country, country->currency map,
   locale root) stay inline as window.GOB_GEO; the logic lives here.

   Timing is unchanged: the block already deferred its own work to
   DOMContentLoaded when the document was still loading, and ran immediately
   otherwise — which is the state a deferred script sees.

   V152 (2026-10-19): shown as a slim top bar instead of a modal; see render().

   Still fails closed. If window.GOB_GEO is missing, currencyFor() finds
   nothing, and no popup is shown.
   ============================================================ */
(function(){
  'use strict';
  /* Liquid values arrive from the small inline block in the snippet — an asset
     file is never rendered through Liquid. Every one of these fails closed:
     no map means no currency, which means no popup. */
  var CFG       = window.GOB_GEO || {};
  var HERE      = CFG.here || '';
  var MAP       = CFG.map  || '';
  var ROOT      = CFG.root || '/';
  var COOKIE    = 'gob_geo_seen';
  var DISMISS_DAYS = 30;

  /* The countries the Europe market serves, i.e. everyone gameofbricks.eu is
     already the right store for. Taken straight from Markets > Europe. The
     France and Germany markets exist but are DISABLED, so FR and DE are served
     by Europe today and belong in this list; if either is ever enabled, move its
     code out of here and give it its own bucket. */
  var EU_MARKET = 'AX,AL,AD,AM,AT,BY,BE,BG,HR,CY,CZ,DK,EE,FO,FI,GE,GR,GL,GP,HU,'+
                  'IS,IE,IT,XK,LV,LT,LU,MT,YT,MC,ME,NL,NO,PL,PT,RO,SM,RS,SK,SI,'+
                  'ES,SJ,SE,CH,TR,UA,VA,JE,FR,DE';

  function cookieGet(n){
    var m = document.cookie.match('(^|;)\\s*'+n+'\\s*=\\s*([^;]+)');
    return m ? m.pop() : '';
  }
  function cookieSet(n,v,days){
    var d=new Date(); d.setTime(d.getTime()+days*864e5);
    document.cookie = n+'='+v+'; expires='+d.toUTCString()+'; path=/; SameSite=Lax';
  }
  /* returns the currency we price that country in, or '' if we do not sell there */
  function currencyFor(code){
    var m = (','+MAP).match(new RegExp(',' + code + ':([A-Z]{3}),'));
    return m ? m[1] : '';
  }

  /* Which of the three storefronts serves a country: the European store, the UK
     subfolder, or the .com store (United States + International + Australia). */
  function storeFor(code){
    if(code === 'GB') return 'GB';
    return (','+EU_MARKET+',').indexOf(','+code+',') > -1 ? 'EU' : 'COM';
  }
  /* Which storefront the shopper is looking at right now. Read off the URL, not
     off Liquid, because the URL is the one thing caching cannot get wrong. */
  function storeHere(){
    if(/^\/(en-)?gb(\/|$)/i.test(location.pathname)) return 'GB';
    return /(^|\.)gameofbricks\.eu$/i.test(location.hostname) ? 'EU' : 'COM';
  }

  /* .eu carries /nl/ and /en-gb/; .com is English-only. Strip a leading xx or
     xx-yy so the shopper lands on the same product on the other domain instead
     of a 404. */
  function carryPath(){
    var p = location.pathname.replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/|$)/i,'') || '/';
    return p + location.search + location.hash;
  }

  /* Klaviyo's teaser and this popup both want the screen. Hold Klaviyo back
     while we are on top, exactly as the previous version did. */
  function klSuppress(on){
    var id='gob-kl-suppress', s=document.getElementById(id);
    if(on){
      if(!s){ s=document.createElement('style'); s.id=id;
        s.textContent='[class*="kl-teaser"],[class*="klaviyo-form"],[class*="klaviyo-close-form"]{display:none !important;}';
        (document.head||document.documentElement).appendChild(s); }
    } else if(s){ s.remove(); }
  }

  /* V152: the modal became a slim bar along the top (styles in gob-smooth.css).
     It never covers the buy box, never takes focus and slides away on close. */
  function close(){
    var w=document.getElementById('gob-geo');
    if(w){
      var gone=function(){ if(w.parentNode) w.parentNode.removeChild(w); };
      var calm = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
      if(calm){ gone(); } else { w.classList.add('is-out'); setTimeout(gone, 320); }
    }
    klSuppress(false);
    cookieSet(COOKIE,'1',DISMISS_DAYS);
    document.removeEventListener('keydown', onKey, true);
  }
  function onKey(e){ if(e.key==='Escape'||e.key==='Esc'){ close(); } }

  function go(code){
    /* Shopify's own localization endpoint. It works out which market owns this
       country and, if that market has its own domain, redirects there. */
    var f=document.createElement('form');
    f.method='post'; f.action=ROOT+'localization'; f.acceptCharset='UTF-8'; f.style.display='none';
    [['form_type','localization'],['utf8','✓'],['_method','put'],
     ['country_code',code],['return_to',carryPath()]].forEach(function(kv){
      var i=document.createElement('input'); i.type='hidden'; i.name=kv[0]; i.value=kv[1]; f.appendChild(i);
    });
    document.body.appendChild(f);
    cookieSet(COOKIE,'1',DISMISS_DAYS);
    f.submit();
  }

  function render(code,name,cur){
    if(document.getElementById('gob-geo')) return;
    /* V152 popup budget: the bar always shows (it is about the right store and
       currency), and claims the visit so the Halloween popup stays away. */
    if(window.GOBPop) window.GOBPop.take('geo');
    var wrap=document.createElement('div');
    wrap.id='gob-geo'; wrap.className='gob-gb';
    wrap.setAttribute('role','region'); wrap.setAttribute('aria-label','Choose your store');
    wrap.innerHTML =
      '<div class="gob-gb__in">'+
        '<p class="gob-gb__t"><b>It looks like you’re in <span class="gob-gb__hl"></span>.</b> '+
          '<span class="gob-gb__sub">Shop our <span class="gob-gb__hl2"></span> store for local pricing'+
          '<span class="gob-gb__cur"></span> and faster delivery.</span></p>'+
        '<button type="button" class="gob-gb__yes"><span class="l"></span><span class="s">Switch store</span></button>'+
        '<button type="button" class="gob-gb__x" aria-label="Stay on this store">&times;</button>'+
      '</div>';
    /* textContent, not innerHTML — the country name comes off the network */
    wrap.querySelector('.gob-gb__hl').textContent  = name;
    wrap.querySelector('.gob-gb__hl2').textContent = name;
    wrap.querySelector('.gob-gb__cur').textContent = cur ? (' in '+cur) : '';
    wrap.querySelector('.gob-gb__yes .l').textContent = 'Go to '+name+' store';
    wrap.querySelector('.gob-gb__yes').addEventListener('click', function(){ go(code); });
    wrap.querySelector('.gob-gb__x').addEventListener('click', close);
    document.body.appendChild(wrap);
    klSuppress(true);
    document.addEventListener('keydown', onKey, true);
  }

  function start(){
    try{
      if(cookieGet(COOKIE)) return;
      var ctl = ('AbortController' in window) ? new AbortController() : null;
      if(ctl) setTimeout(function(){ try{ ctl.abort(); }catch(e){} }, 4000);
      fetch(ROOT+'browsing_context_suggestions.json?country[enabled]=true',
            { headers:{'Accept':'application/json'}, signal: ctl?ctl.signal:undefined })
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(j){
          if(!j || !j.detected_values || !j.detected_values.country) return;
          var code = j.detected_values.country.handle;
          var name = j.detected_values.country_name || j.detected_values.country.name;
          if(!code || !name) return;
          var cur = currencyFor(code);
          if(!cur) return;                            // we do not sell there
          if(code === HERE) return;                   // same country, nothing to offer
          if(storeFor(code) === storeHere()) return;  // already on the right storefront
          render(code, name, cur);
        })
        .catch(function(){});                // fail closed: no popup, no error
    }catch(e){}
  }

  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', start); }
  else { start(); }
})();
